import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { Message, Icon } from 'semantic-ui-react';
import { removeNotification } from "../../redux/actions";
import { Link } from "react-router-dom";

const Notification = () => {
  const {t} = useTranslation()
  const notification = useSelector((state) => state.notification);
  const dispatch = useDispatch();

  const style = {
    container: {
      zIndex: 100,
      position: 'fixed',
      right: 0,
      top: 0,
      margin: 20
    },
    message: {
      animation:' flyin 1.2s ease forwards',
      opacity: 0,
      transform: 'scale(2)',
      background: 'rgba(0, 0, 0, .7)',
      color: 'rgba(255,255,255,.9)',
    }
  }

  useEffect(() => {
    if (!notification?.length) return;

    const timers = notification.map((element) =>
      setTimeout(() => {
        dispatch(removeNotification(element.id));
      }, 5000)
    );

    return () => {
      timers.forEach(clearTimeout);
    };
  }, [notification, dispatch]);
  
  if(!notification)
    return null

  return(
    <div style={style.container}>
      {notification.map((element, index) =>{
        return(
          <Message
            key={`notification-message-#${element.id}`}
            onDismiss={()=>dispatch(removeNotification(element.id))} 
            icon
            size='tiny'
            style={style.message}
          >
            <Icon name={element.icon ? element.icon : 'info'} />
            <Message.Content>
              <Message.Header>{element.header}</Message.Header>

              <div style={{ marginTop: '4px' }}>
                {element.content}
              </div>

              {element.type === 'cart' && (
                <div style={{ marginTop: '8px' }}>
                  <Link
                    to="/checkout#checkout-data"
                    style={{
                      color: '#fff',
                      textDecoration: 'underline',
                      fontSize: '12px',
                      opacity: 0.9
                    }}
                  >
                    {t('header-menu-cart')}
                  </Link>
                </div>
              )}
            </Message.Content>
          </Message>
        )
      })}
    </div>
  )
}

export default Notification